// mouse Hover Effect services carts
function mouseHover() {
    let animatedElements = document.querySelectorAll('.mouseOverLight'); // Ensure correct spelling for variable name
    if (animatedElements) {
        animatedElements.forEach(el => {
            // Create shadow for each element and append it
            let shadow = document.createElement('div');
            shadow.classList.add('shadow');

            // Ensure the parent element has a relative position
            let parent = el.parentNode;
            parent.style.position = 'relative';

            // Add the shadow to the parent element
            parent.appendChild(shadow);

            // Mouse move event to update shadow position
            parent.addEventListener('mousemove', (e) => {
                let rect = parent.getBoundingClientRect();
                let x = e.clientX - rect.left;
                let y = e.clientY - rect.top;

                // Set the shadow's position
                shadow.style.opacity = '1';
                shadow.style.top = `${y}px`;
                shadow.style.left = `${x}px`;

                // Optionally, you can animate the shadow's movement with CSS transitions
                shadow.animate({
                    left: `${x}px`,
                    top: `${y}px`
                }, {
                    duration: 500,
                    fill: 'forwards'
                })

            });

            // Mouse leave event to hide the shadow
            parent.addEventListener('mouseleave', () => {
                shadow.style.opacity = '0';
            });
        });
    }
}

function scrollAnimation() {
    // Callback function for the IntersectionObserver
    function callback(entries, observer) {
        entries.forEach(entry => {
            const target = entry.target;

            // As the element enters the viewport, we scale and move it up
            if (entry.intersectionRatio > 0) {
                // Set a translateY value based on intersectionRatio to animate the element from bottom
                target.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-in-out';
                target.style.transform = `translateY(${(1 - entry.intersectionRatio) * 100}px)`; // Move from below
                target.style.opacity = entry.intersectionRatio; // Fade in based on visibility
            } else {
                // Reset properties when out of view
                target.style.transform = 'translateY(100px)';
                target.style.opacity = '0';
            }
        });
    }

    // Define observer options
    const options = {
        threshold: Array.from({
            length: 101
        }, (_, i) => i / 100),
    };

    // Create a new IntersectionObserver instance
    let observer = new IntersectionObserver(callback, options);

    // Observe each '.project' element
    document.querySelectorAll('.scroll_animate').forEach(target => {
        observer.observe(target);
    });
}

function scrolling() {
    window.addEventListener('scroll', () => {
        let icon = document.querySelector('.goToTopIcon');
        if (icon) {
            let goTopBtn = document.querySelector('.go_to_top');
            let header = document.querySelector('header');
            let parent = icon.parentElement;
            if (window.scrollY > 800) {
                goTopBtn.classList.add('active');
                parent.href = '#home';
                header.style.paddingTop = '0';
                icon.innerHTML = '<i class="fa-solid fa-arrow-up"></i>';
            } else {
                goTopBtn.classList.remove('active');
                header.style.paddingTop = '15px';
                parent.href = '#about_me';
                icon.innerHTML = '<i class="fa-solid fa-arrow-down"></i>';
            }
        }
    });
}

mouseHover();
scrolling();
scrollAnimation();
if (!window.__clientAppInitialized) {

    window.__clientAppInitialized = true;

    const backToTop = document.getElementById('backToTop');

    const progress = document.getElementById('progress');

    const navProgress = document.querySelector('.nav_progress');

    const nav = document.querySelector('nav');

    const body = document.querySelector('body');



    function handleNavbar() {

        let navLinks = document.querySelectorAll('.nav_link');

        navLinks.forEach(link => {

            link.addEventListener('click', () => body.classList.remove('nav-open'));

        });



        body.addEventListener('click', (e) => {

            if (e.target.classList.contains('mobile-overlay')) {

                body.classList.remove('nav-open');

            }

        });

    }



    function inputField() {

        let inputField = document.querySelectorAll('.input_field');



        inputField.forEach(element => {

            const input = element.querySelector('input');

            const span = element.querySelector('span');

            handleInputChange(input, span)



            // Add an event listener for user input

            input.addEventListener('input', () => handleInputChange(input, span));

        });



        function handleInputChange(input, span) {

            const hasValue = input.value.trim() !== '';

            if (input !== null && span !== null) hasValue ? span.classList.add('active') : span.classList.remove('active')

        }

    }



    // Optimized Scroll Handler using requestAnimationFrame

    let ticking = false;

    function updateOnScroll() {

        const scrollTop = window.scrollY;

        

        // Navbar Sticky

        if (nav) {

            if (scrollTop > 700) {

                nav.classList.add('sticky');

            } else {

                nav.classList.remove('sticky');

            }

        }



        // Back to Top & Progress

        if (progress || backToTop) {

            const docHeight = document.documentElement.scrollHeight - window.innerHeight;

            const scrollPercent = (scrollTop / docHeight) * 100;



            if (backToTop) {

                if (scrollTop > 700) backToTop.classList.add('active');

                else backToTop.classList.remove('active');



                if (Math.round(scrollPercent) > 60) {

                    backToTop.style.color = '#fff';

                } else {

                    backToTop.style.color = 'var(--primary-color)';

                }

            }



            if (progress) progress.style.width = scrollPercent + "%";

            if (navProgress) navProgress.style.width = scrollPercent + "%";

        }

        

        ticking = false;

    }



    window.addEventListener('scroll', () => {

        if (!ticking) {

            window.requestAnimationFrame(updateOnScroll);

            ticking = true;

        }

    });



    if (backToTop) {

        backToTop.addEventListener('click', () => {

            window.scrollTo({

                top: 0,

                behavior: 'smooth',

            });

        });

    }



    // account profile check gender fields

    document.addEventListener('click', (e) => {

        if (e.target.classList.contains('gender')) {



            const input = e.target.closest('input');

            document.querySelectorAll('label').forEach(el => el.style.border = '1px solid #ddd')



            e.target.closest('label').style.border = '1px solid #ccc';

            setTimeout(() => {

                if (input.checked) {

                    e.target.closest('label').style.border = '1px solid #444cf7';

                } else {

                    e.target.closest('label').style.border = '1px solid #ccc';

                }

            }, 10);

        }

    });



    Array.from(document.querySelectorAll('form')).forEach(form => {

        if (form.id === 'resetPasswordForm' || form.classList.contains('manual-submit')) return;

        form.addEventListener('submit', async (e) => {

            e.preventDefault();



            if (!validateBootstrap(form)) {

                showNotification("Խնդրում ենք լրացնել բոլոր պարտադիր դաշտերը", 'warning', 3000);

                return;

            }



            const button = form.querySelector('button[type="submit"]');

            const formData = new FormData(form);

            const URL = form.getAttribute('action');

            const METHOD = form.getAttribute('method') ?.toLowerCase();



            // Save original button state

            const originalContent = button.innerHTML;

            

            // Disable and show loading state

            button.disabled = true;

            button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Խնդրում ենք սպասել...';

            

            setFormLoading(form, true);



            let reopenDelay = 2000;



            try {

                let dataToSend = formData;

                if (METHOD !== 'patch' && METHOD !== 'post') {

                    dataToSend = Object.fromEntries(formData.entries());

                }



                const response = await doAxios(URL, METHOD, dataToSend);

                if (response ?.error || response ?.status >= 400) {

                    showNotification(response.message || 'Խնդրում ենք կրկին փորձել', 'warning', 3000);

                    reopenDelay = 3000;

                } else {

                    showNotification('Հաջողությամբ ստացվեց', 'success', 2000);

                    const redirect = response ?.data ?.redirect || form.getAttribute('data-redirect');

                    const shouldReload = Boolean(response ?.data ?.reload) ||

                        form.getAttribute('data-reload') === '1';

                    

                    if (redirect) setTimeout(() => window.location.assign(redirect), 2000);

                    if (shouldReload) setTimeout(() => window.location.reload(), 2000);

                    

                    if (shouldReload && !window.__allowReload) {

                        window.__allowReload = true;

                        setTimeout(() => window.location.reload(), 2000);

                        return;

                    }

                }

            } catch (err) {

                showNotification(

                    err ?.response ?.data ?.message || 'Ցանցի սխալ',

                    'warning'

                );

                reopenDelay = 3000;

            }



            setTimeout(() => {

                setFormLoading(form, false);

                button.disabled = false;

                button.innerHTML = originalContent;

            }, reopenDelay);

        });

    });



    // Newsletter specific handler

    const newsletterForms = document.querySelectorAll('.newsletter-form');

    newsletterForms.forEach(newsletterForm => {

        newsletterForm.addEventListener('submit', async (e) => {

            e.preventDefault();

            

            // Basic validation

            if (!newsletterForm.checkValidity()) {

                newsletterForm.reportValidity();

                return;

            }



            const button = newsletterForm.querySelector('button[type="submit"]');

            const formData = new FormData(newsletterForm);

            const URL = newsletterForm.getAttribute('action');

            const METHOD = newsletterForm.getAttribute('method')?.toLowerCase() || 'post';



            const originalContent = button.innerHTML;

            button.disabled = true;

            // Minimal loading indicator for small button

            button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';

            

            setFormLoading(newsletterForm, true);



            try {

                let dataToSend = formData;

                if (METHOD !== 'patch' && METHOD !== 'post') {

                    dataToSend = Object.fromEntries(formData.entries());

                }



                const response = await doAxios(URL, METHOD, dataToSend);

                if (response?.error || response?.status >= 400) {

                    showNotification(response.message || 'Խնդրում ենք կրկին փորձել', 'warning', 3000);

                } else {

                    showNotification('Դուք հաջողությամբ բաժանորդագրվեցիք', 'success', 3000);

                    newsletterForm.reset();

                }

            } catch (err) {

                showNotification(err?.response?.data?.message || 'Ցանցի սխալ', 'warning');

            }



            setTimeout(() => {

                setFormLoading(newsletterForm, false);

                button.disabled = false;

                button.innerHTML = originalContent;

            }, 1000);

        });

    });



    function resetPassword() {

        const form = document.getElementById('resetPasswordForm');

        const token = '<%= token %>';

        const togglePasswordBtn = document.getElementById('togglePassword');

        const passwordInput = document.getElementById('password');





        // Toggle password visibility

        togglePasswordBtn.addEventListener('click', function () {

            const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';

            passwordInput.setAttribute('type', type);

            this.querySelector('i').classList.toggle('fa-eye');

            this.querySelector('i').classList.toggle('fa-eye-slash');

        });



        form.addEventListener('submit', async function (e) {

            e.preventDefault();



            if (!form.checkValidity()) {

                e.stopPropagation();

                form.classList.add('was-validated');

                return;

            }



            const password = document.getElementById('password').value;

            const passwordConfirm = document.getElementById('passwordConfirm').value;



            if (password !== passwordConfirm) {

                showNotification('Գաղտնաբառերը չեն համընկնում', 'error');

                return;

            }



            try {

                const submitBtn = form.querySelector('button[type="submit"]');

                const originalText = submitBtn.innerHTML;

                submitBtn.disabled = true;

                submitBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Կատարվում է...';



                const response = await doAxios(`/api/v1/user/resetPassword/${token}`, 'POST', {

                    password

                });



                if (response.success) {

                    showNotification('Գաղտնաբառը հաջողությամբ փոխվեց', 'success');

                    setTimeout(() => {

                        window.location.href = '/';

                    }, 1500);

                } else {

                    showNotification(response.message || 'Սխալ տեղի ունեցավ', 'error');

                    submitBtn.disabled = false;

                    submitBtn.innerHTML = originalText;

                }

            } catch (err) {

                console.error(err);

                showNotification('Սխալ տեղի ունեցավ', 'error');

                const submitBtn = form.querySelector('button[type="submit"]');

                submitBtn.disabled = false;

                submitBtn.innerHTML = 'Պահպանել գաղտնաբառը';

            }

        });

    }



    handleNavbar();

    inputField();

}
document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll("[data-crop-wrapper]").forEach(wrapper => {

        const prefix = wrapper.dataset.cropWrapper; 
        const selectBtn = wrapper.querySelector("[data-crop-select]");
        const fileInput = wrapper.querySelector("input[type='file']");

        const modalId = `${prefix}_modal`;
        const imgId = `${prefix}_img`;
        const saveBtnAttr = `[data-crop-save="${prefix}"]`;

        const modalEl = document.getElementById(modalId);
        const cropModal = new bootstrap.Modal(modalEl, { keyboard: true, backdrop: 'static' });

        const imageEl = document.getElementById(imgId);
        const saveBtn = modalEl.querySelector(saveBtnAttr);
        const reselectBtn = modalEl.querySelector(`[data-crop-reselect="${prefix}"]`);
        const deleteBtn = modalEl.querySelector(`[data-crop-delete="${prefix}"]`);
        const cancelBtn = modalEl.querySelector(`[data-crop-cancel="${prefix}"]`);
        const rotateLeftBtn = modalEl.querySelector(`[data-crop-rotate-left="${prefix}"]`);
        const rotateRightBtn = modalEl.querySelector(`[data-crop-rotate-right="${prefix}"]`);
        const aspectBtns = modalEl.querySelectorAll(`[data-crop-aspect="${prefix}"]`);

        let cropper = null;
        let currentObjectUrl = null;
        let saving = false;
        let currentAspectRatio = 1; // Default to square for profile images
        
        const getOpts = () => ({
            aspectRatio: currentAspectRatio,
            viewMode: 2,
            dragMode: 'move',
            background: false,
            responsive: true,
            checkOrientation: false,
            toggleDragModeOnDblclick: false,
            zoomOnWheel: false,
            zoomOnTouch: false,
            guides: true,
            center: true,
            highlight: true,
            minContainerWidth: 320,
            minContainerHeight: 200,
            autoCropArea: 0.9,
            cropBoxMovable: true,
            cropBoxResizable: true
        });
        
        function initCropper() {
            if (cropper) { cropper.destroy(); cropper = null; }
            cropper = new Cropper(imageEl, getOpts());
        }
        
        // Rotation handlers
        if (rotateLeftBtn) {
            rotateLeftBtn.addEventListener('click', () => {
                if (cropper) cropper.rotate(-90);
            });
        }
        
        if (rotateRightBtn) {
            rotateRightBtn.addEventListener('click', () => {
                if (cropper) cropper.rotate(90);
            });
        }
        
        // Aspect ratio switching
        aspectBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                if (!cropper) return;
                
                // Update active state
                aspectBtns.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                
                // Set aspect ratio
                const aspect = btn.dataset.aspect;
                currentAspectRatio = aspect === 'NaN' ? NaN : parseFloat(aspect);
                cropper.setAspectRatio(currentAspectRatio);
            });
        });
        
        // Cancel button
        if (cancelBtn) {
            cancelBtn.addEventListener('click', () => {
                cropModal.hide();
            });
        }

        selectBtn.addEventListener("click", () => fileInput.click());

        // External trigger (e.g., profile image click)
        const triggers = document.querySelectorAll(`[data-crop-trigger="${prefix}"]`);
        triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const currentSrc = trigger.getAttribute('src') || '';
                const isDefault = /no-image-profile\.jpg$/i.test(currentSrc);
                
                let srcToUse = currentSrc;
                if (!srcToUse && trigger.tagName !== 'IMG') {
                    const profileImg = document.querySelector('.profile-img-lg');
                    if (profileImg) {
                        srcToUse = profileImg.src;
                    }
                }

                if (srcToUse && !isDefault) {
                    if (cropper) { cropper.destroy(); cropper = null; }
                    if (currentObjectUrl) { URL.revokeObjectURL(currentObjectUrl); currentObjectUrl = null; }
                    imageEl.src = srcToUse;
                    imageEl.style.maxHeight = '70vh';
                    imageEl.style.maxWidth = '100%';
                    imageEl.style.objectFit = 'contain';
                    cropModal.show();
                } else {
                    selectBtn.click();
                }
            });
        });

        // 2) crop modal
        fileInput.addEventListener("change", e => {
            const file = e.target.files[0];
            if (!file) return;

            if (fileInput.dataset.cropped === '1') {
                delete fileInput.dataset.cropped;
                return;
            }

            if (cropper) {
                cropper.destroy();
                cropper = null;
            }
            if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
            currentObjectUrl = URL.createObjectURL(file);
            imageEl.src = currentObjectUrl;
            imageEl.style.maxHeight = '70vh';
            imageEl.style.maxWidth = '100%';
            imageEl.style.objectFit = 'contain';
            if (modalEl.classList.contains('show')) { initCropper(); } else { cropModal.show(); }
        });

        if (reselectBtn) {
            reselectBtn.addEventListener('click', () => fileInput.click());
        }

        if (deleteBtn) {
            deleteBtn.addEventListener('click', async () => {
                const confirmed = await showConfirm({
                    title: 'Վստա՞հ եք',
                    message: 'Ջնջել պրոֆիլի նկարը',
                    confirmText: 'Այո, ջնջել',
                    cancelText: 'Չեղարկել',
                    timeout: 3000
                });
                if (!confirmed) return;
                try {
                    const res = await doAxios('/api/v1/user/avatar', 'delete');
                    
                    // Helper to generate color index from name
                    const getBgClass = (name) => {
                        let hash = 0;
                        for (let i = 0; i < name.length; i++) {
                            hash = name.charCodeAt(i) + ((hash << 5) - hash);
                        }
                        const index = Math.abs(hash) % 10;
                        return `bg-${index}`;
                    };

                    const updateToPlaceholder = (imgElement, isSmall = false) => {
                        if (!imgElement) return;
                        
                        let name = '';
                        
                        // 1. For Profile Page (Large Image), prioritize the visible name in header
                        if (!isSmall) {
                            const nameEl = document.querySelector('.profile-info h3');
                            if (nameEl) name = nameEl.innerText.trim();
                        }

                        // 2. For Navbar (Small Image), use tooltip
                        if (!name && isSmall) {
                             const parentLink = imgElement.closest('a');
                             if (parentLink && parentLink.dataset.bsTitle) {
                                 name = parentLink.dataset.bsTitle;
                             }
                        }

                        // 3. Fallback to Alt text (ignoring generic "Profile")
                        if (!name && imgElement.alt && imgElement.alt !== 'Profile') {
                            name = imgElement.alt;
                        }

                        // 4. Final Fallback
                        if (!name) name = 'User';

                        const initial = name.charAt(0).toUpperCase();
                        const bgClass = getBgClass(name);

                        const div = document.createElement('div');
                        
                        if (isSmall) {
                            // Navbar style
                            div.className = `profime-sm-image border border-primary border-2 d-flex align-items-center justify-content-center text-white ${bgClass}`;
                            div.innerHTML = `<span style="font-size: 1.2rem; line-height: 1;">${initial}</span>`;
                        } else {
                            // Profile page style
                            div.className = 'profile-img-lg d-flex align-items-center justify-content-center text-uppercase fw-bold placeholder-wrapper';
                            div.innerHTML = `<div class="profile-placeholder-img rounded-circle ${bgClass}">${initial}</div>`;
                        }

                        imgElement.replaceWith(div);
                    };

                    const profileImgLg = document.querySelector('.profile-img-lg'); // Profile page main image
                    const smallImg = document.querySelector('.profime-sm-image');   // Navbar image

                    // Check if they are images before replacing (they might already be placeholders)
                    if (profileImgLg && profileImgLg.tagName === 'IMG') {
                        updateToPlaceholder(profileImgLg, false);
                    }
                    if (smallImg && smallImg.tagName === 'IMG') {
                        updateToPlaceholder(smallImg, true);
                    }

                    showNotification('Նկարը ջնջվեց', 'success', 3000);
                    setTimeout(() => window.location.reload(), 1000);
                } catch (e) {
                    showNotification('Չհաջողվեց ջնջել նկարը', 'error', 3000);
                    return;
                }
                cropModal.hide();
                if (cropper) { cropper.destroy(); cropper = null; }
                imageEl.src = '';
                if (currentObjectUrl) { URL.revokeObjectURL(currentObjectUrl); currentObjectUrl = null; }
            });
        }

        modalEl.addEventListener("shown.bs.modal", () => {
            requestAnimationFrame(() => { initCropper(); });
        });

        // 4) Cleanup
        modalEl.addEventListener("hidden.bs.modal", () => {
            if (saving) return; 
            if (cropper) {
                cropper.destroy();
                cropper = null;
            }
            imageEl.src = "";
            if (currentObjectUrl) {
                URL.revokeObjectURL(currentObjectUrl);
                currentObjectUrl = null;
            }
        });

        // 5)  crop–ը
        saveBtn.addEventListener("click", () => {
            if (!cropper) return;
            saving = true;

            // Loading state
            const originalHtml = saveBtn.innerHTML;
            saveBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-2"></i>Պահպանվում է...';
            saveBtn.disabled = true;

            const canvas = cropper.getCroppedCanvas({ maxWidth: 720, maxHeight: 720 });
            canvas.toBlob(async blob => {
                const formData = new FormData();
                const fieldName = fileInput.name || 'user_img';
                formData.append(fieldName, blob, 'user_img.jpg');

                // Add CSRF token to FormData
                const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content ||
                                  document.cookie.split('; ').find(row => row.startsWith('_csrf='))?.split('=')[1];
                if (csrfToken) {
                    formData.append('_csrf', csrfToken);
                }

                try {
                    const res = await doAxios('/api/v1/user/updateme', 'PATCH', formData);

                    if (res.success) {
                        const previewUrl = URL.createObjectURL(blob);
                        
                        // Update UI immediately
                        const profileImg = document.querySelector('.profile-img');
                        const profileImgLg = document.querySelector('.profile-img-lg');
                        const smallImg = document.querySelector('.profime-sm-image');
                        
                        if (profileImg) profileImg.src = previewUrl;
                        if (profileImgLg) profileImgLg.src = previewUrl;
                        if (smallImg) smallImg.src = previewUrl;

                        showNotification('Նկարը հաջողությամբ պահպանվեց', 'success', 2000);
                        cropModal.hide();
                        setTimeout(() => window.location.reload(), 1000);
                    } else {
                        showNotification(res.message || 'Սխալ տեղի ունեցավ', 'error', 3000);
                    }
                } catch (e) {
                    // console.error(e);
                    showNotification('Սխալ տեղի ունեցավ', 'error', 3000);
                } finally {
                    saveBtn.innerHTML = originalHtml;
                    saveBtn.disabled = false;
                    saving = false;

                    if (cropper) { cropper.destroy(); cropper = null; }
                    imageEl.src = "";
                    if (currentObjectUrl) { URL.revokeObjectURL(currentObjectUrl); currentObjectUrl = null; }
                }
            }, 'image/jpeg', 0.85);
        });

    });
});

document.addEventListener('DOMContentLoaded', function() {
    const galleryItems = document.querySelectorAll('.gallery-item');
    const loadMoreBtn = document.getElementById('loadMoreBtn');
    const loadMoreText = document.getElementById('loadMoreText');
    const loadMoreIcon = loadMoreBtn ? loadMoreBtn.querySelector('i') : null;
    
    let currentItems = 8;
    const itemsPerLoad = 8;
    const totalItems = galleryItems.length;

    // Initial check
    if (totalItems <= 8) {
        if(loadMoreBtn) loadMoreBtn.style.display = 'none';
    }

    if(loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function(e) {
            e.preventDefault();

            // Check if we are in "Close" mode
            const isCloseMode = loadMoreText.textContent.trim() === 'Փակել';

            if (isCloseMode) {
                // Collapse logic
                currentItems = 8;
                galleryItems.forEach((item, index) => {
                    if (index >= currentItems) {
                        item.classList.add('hidden-item');
                        item.classList.remove('fade-in');
                    }
                });
                
                loadMoreText.textContent = 'Բեռնել ավելին';
                if(loadMoreIcon) {
                    loadMoreIcon.className = 'fas fa-chevron-down';
                }
                
                // Scroll back to gallery top smoothly
                const gallerySection = document.getElementById('gallery');
                if(gallerySection) gallerySection.scrollIntoView({ behavior: 'smooth' });
            } else {
                // Load More Logic with Animation
                
                // 1. Show loading state
                const originalText = loadMoreText.textContent;
                loadMoreText.textContent = 'Բեռնվում է...';
                loadMoreBtn.classList.add('loading');
                if(loadMoreIcon) {
                    loadMoreIcon.className = 'fas fa-spinner fa-spin';
                }
                loadMoreBtn.disabled = true;

                // 2. Simulate delay (animation)
                setTimeout(() => {
                    const nextItems = currentItems + itemsPerLoad;
                    const limit = Math.min(nextItems, totalItems);
                    
                    for (let i = currentItems; i < limit; i++) {
                        if (galleryItems[i]) {
                            galleryItems[i].classList.remove('hidden-item');
                            // Adding class triggers animation if defined in CSS
                            galleryItems[i].classList.add('fade-in');
                        }
                    }
                    
                    currentItems = limit;

                    // 3. Update Button State
                    loadMoreBtn.disabled = false;
                    loadMoreBtn.classList.remove('loading');
                    
                    if (currentItems >= totalItems) {
                        loadMoreText.textContent = 'Փակել';
                        if(loadMoreIcon) {
                            loadMoreIcon.className = 'fas fa-chevron-up';
                        }
                    } else {
                        loadMoreText.textContent = 'Բեռնել ավելին';
                        if(loadMoreIcon) {
                            loadMoreIcon.className = 'fas fa-chevron-down';
                        }
                    }

                }, 800); // 800ms delay for loading animation
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', async () => {

    // 1. Data from DOM

    const root = document.getElementById("groupRoot");

    if (!root) return;

    

    let groupData = {};

    try {

        groupData = JSON.parse(root.dataset.group);

    } catch (e) {

        // console.error("Error parsing group data", e);

        return;

    }



    if (!groupData || !groupData.id) {

        // console.error('Group data not found');

        return;

    }



    // 2. State

    let userAnswers = {}; 

    let totalQuestions = 0;

    let currentLimit = 20;

    let startTime = Date.now();

    

    // Fix: Scope storage to user

    const userId = root.dataset.userId || 'guest';

    const STORAGE_KEY = `mg_user_${userId}_group_${groupData.id}_answers`;



    // 3. DOM Elements

    const els = {

        container: document.getElementById('questions-container'),

        totalCountBadge: document.getElementById('totalCountBadge'),

        resultModal: typeof bootstrap !== 'undefined' ? new bootstrap.Modal(document.getElementById('resultModal')) : null,

        correctCount: document.getElementById('correctCount'),

        wrongCount: document.getElementById('wrongCount'),

        timeSpentBadge: document.getElementById('timeSpentBadge'),

        scorePercent: document.getElementById('scorePercent'),

        limitSelect: document.getElementById('limitSelect'),

        pagination: document.getElementById('questionsPag'),

        btnRetry: document.getElementById('btnRetry'),

        resetProgressBtn: document.getElementById('resetProgressBtn'),

        resetConfirmModal: typeof bootstrap !== 'undefined' ? new bootstrap.Modal(document.getElementById('resetConfirmModal')) : null,

        confirmResetBtnAction: document.getElementById('confirmResetBtnAction')

    };



    // 4. Initialization Logic

    async function init() {

        try {

            const urlParams = new URLSearchParams(window.location.search);



            // Restore answers from DB

            userAnswers = await loadProgressDB();

            

            // Restore limit from URL

            const limitParam = urlParams.get('limit');

            if (limitParam) {

                currentLimit = parseInt(limitParam);

                if (els.limitSelect) els.limitSelect.value = currentLimit;

            }



            // Initial Load

            const page = parseInt(urlParams.get('page')) || 1;

            await loadQuestions(page);



        } catch (error) {

            // console.error('Error initializing group details:', error);

            showNotification('Սխալ տեղի ունեցավ էջը բեռնելիս: ' + error.message, 'error');

        }

    }



    // 5. Event Listeners



    // Retry Button

    if(els.btnRetry) {

        els.btnRetry.addEventListener('click', clearAndReload);

    }



    // Reset Progress Button

    if(els.resetProgressBtn) {

        els.resetProgressBtn.addEventListener('click', () => {

             if (els.resetConfirmModal) {

                 els.resetConfirmModal.show();

             } else if(confirm('Ցանկանու՞մ եք սկսել նորից: Բոլոր պատասխանները կջնջվեն:')) {

                 performReset();

             }

        });

    }



    // Modal Action

    if(els.confirmResetBtnAction) {

        els.confirmResetBtnAction.addEventListener('click', async () => {

            const btn = els.confirmResetBtnAction;

            const originalContent = btn.innerHTML;

            btn.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';

            btn.disabled = true;

            

            await performReset(btn, originalContent);

        });

    }



    async function performReset(btn = null, originalContent = '') {

         try {

            // console.log('Resetting progress...');

            userAnswers = {};

            const success = await saveProgressDB({});

            

            if (success) {

                const url = new URL(window.location);

                url.searchParams.set('page', 1);

                window.location.href = url.toString();

            } else {

                showNotification('Սխալ տեղի ունեցավ: Չհաջողվեց ջնջել տվյալները:', 'error');

                if(btn) {

                    btn.innerHTML = originalContent;

                    btn.disabled = false;

                    if(els.resetConfirmModal) els.resetConfirmModal.hide();

                }

            }

        } catch (e) {

            console.error('Error resetting progress', e);

            showNotification('Սխալ տեղի ունեցավ', 'error');

            if(btn) {

                 btn.innerHTML = originalContent;

                 btn.disabled = false;

                 if(els.resetConfirmModal) els.resetConfirmModal.hide();

            }

        }

    }



    // Filter Listener

    if(els.limitSelect) {

        els.limitSelect.addEventListener('change', (e) => {

            currentLimit = Number(e.target.value);

            

            // Update URL for limit

            const url = new URL(window.location);

            url.searchParams.set('limit', currentLimit);

            url.searchParams.set('page', 1); 

            history.replaceState({}, "", url);



            loadQuestions(1);

        });

    }



    // Event Delegation for Questions Container

    if(els.container) {

        els.container.addEventListener('click', (e) => {

            // Option Click

            const optionDiv = e.target.closest('.answer-option');

            if(optionDiv && !optionDiv.classList.contains('disabled')) {

                const globalIndex = parseInt(optionDiv.dataset.globalIndex);

                const optIdx = parseInt(optionDiv.dataset.optIdx);

                const correctIdx = parseInt(optionDiv.dataset.correctIdx);

                checkAnswer(globalIndex, optIdx, correctIdx);

                return;

            }



            // Image Click

            const imgWrapper = e.target.closest('.question-image-wrapper');

            if(imgWrapper) {

                const img = imgWrapper.querySelector('img');

                if(img) openImageModal(img.src);

            }

        });

    }



    // 6. Core Functions



    async function saveProgressDB(answers) {

        try {

            const res = await fetch(`/api/v1/groups/${groupData.id}/progress`, {

                method: 'POST',

                headers: { 'Content-Type': 'application/json' },

                body: JSON.stringify({ answers })

            });

            if (!res.ok) {

                console.error('Failed to save progress:', res.status);

                return false;

            }

            return true;

        } catch (e) {

            console.error('Error saving progress to DB', e);

            return false;

        }

    }



    async function loadProgressDB() {

        try {

            const res = await fetch(`/api/v1/groups/${groupData.id}/progress`);

            const json = await res.json();

            if (json.status === 'success' && json.answers) {

                return json.answers;

            }

        } catch (e) {

            console.error('Error loading progress from DB', e);

        }

        return {};

    }



    function renderPaginationInline(total, limit, currentPage) {

        const container = els.pagination;

        if(!container) return;

        container.innerHTML = '';

        

        const totalPages = Math.ceil(total / limit);

        if(totalPages <= 0) return;



        const nav = document.createElement("div");

        nav.className = "pagination-nav";

        const ul = document.createElement("ul");

        ul.className = "pagination justify-content-center flex-wrap";



        const createPageItem = (page, text, isActive = false, isDisabled = false) => {

            const li = document.createElement("li");

            li.className = `page-item ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`;

            

            const a = document.createElement("a");

            a.className = "page-link";

            a.innerHTML = text;

            a.href = "#";

            

            if(!isDisabled && !isActive) {

                a.onclick = (e) => {

                    e.preventDefault();

                    updatePage(page);

                };

            }

            

            li.appendChild(a);

            ul.appendChild(li);

        };



        // Prev

        createPageItem(currentPage - 1, '<i class="fa-solid fa-chevron-left"></i>', false, currentPage === 1);



        // Pages

        if (totalPages <= 7) {

                for(let i=1; i<=totalPages; i++) createPageItem(i, i, i === currentPage);

        } else {

                createPageItem(1, 1, 1 === currentPage);

                if(currentPage > 3) createPageItem(null, '...', false, true);

                

                let start = Math.max(2, currentPage - 1);

                let end = Math.min(totalPages - 1, currentPage + 1);

                

                if (currentPage <= 3) end = 4;

                if (currentPage >= totalPages - 2) start = totalPages - 3;

                

                for(let i=start; i<=end; i++) createPageItem(i, i, i === currentPage);

                

                if(currentPage < totalPages - 2) createPageItem(null, '...', false, true);

                createPageItem(totalPages, totalPages, totalPages === currentPage);

        }



        // Next

        createPageItem(currentPage + 1, '<i class="fa-solid fa-chevron-right"></i>', false, currentPage === totalPages);



        nav.appendChild(ul);

        container.appendChild(nav);

        container.style.display = 'flex';

    }



    function updatePage(page) {

        const url = new URL(window.location);

        url.searchParams.set('page', page);

        history.replaceState({}, "", url);

        loadQuestions(page);

    }



    async function clearAndReload() {

        try {

            await saveProgressDB({});

        } catch (e) {

            console.error("Error clearing progress:", e);

        }

        

        const url = new URL(window.location);

        url.searchParams.delete('retry');

        url.searchParams.set('page', 1);

        window.location.href = url.toString();

    }



    async function loadQuestions(page) {

        els.container.innerHTML = `

            <div class="text-center py-5">

                <div class="spinner-border text-primary" role="status">

                    <span class="visually-hidden">Loading...</span>

                </div>

                <p class="mt-3 text-muted">Հարցերի բեռնում...</p>

            </div>

        `;

        

        try {

            const res = await fetch(`/api/v1/groups/${groupData.id}/questions?page=${page}&limit=${currentLimit}`);

            if (!res.ok) throw new Error('Network response was not ok');

            

            const json = await res.json();

            

            if (json.status === 'success') {

                const { total, questions } = json.data;

                totalQuestions = total;

                

                // Auto-reset if test was fully completed previously

                if (total > 0 && Object.keys(userAnswers).length >= total) {

                    console.log('Test was fully completed previously, resetting for fresh start.');

                    userAnswers = {};

                    saveProgressDB({});

                }



                renderPaginationInline(total, currentLimit, page);

                

                if(els.totalCountBadge) els.totalCountBadge.innerText = `Ընդհանուր: ${total} հարց`;



                const startIndex = (page - 1) * currentLimit;

                renderQuestions(questions, startIndex);

                

                const headerCard = document.querySelector('.test-header-card');

                if(headerCard) headerCard.scrollIntoView({ behavior: 'smooth' });



            } else {

                throw new Error(json.message || 'Unknown error');

            }

        } catch (err) {

            els.container.innerHTML = `<div class="alert alert-danger">Սխալ: ${err.message}</div>`;

        }

    }



    function renderQuestions(list, startGlobalIndex) {

        els.container.innerHTML = '';

        

        if (list.length === 0) {

            els.container.innerHTML = '<div class="alert alert-info">Այս էջում հարցեր չկան:</div>';

            return;

        }



        list.forEach((q, i) => {

            const globalIndex = startGlobalIndex + i;

            const questionDiv = document.createElement('div');

            questionDiv.className = 'question-item animate__animated animate__fadeIn';

            questionDiv.id = `question-${globalIndex}`;

            

            // Image HTML

            let imageHtml = '';

            if (q.files && q.files.length > 0) {

                const file = q.files[0];

                const imgSrc = `/images/questions/large/${file.name}.${file.ext}`;

                // Removed onclick, handled by event delegation

                imageHtml = `

                    <div class="question-image-wrapper">

                        <img src="${imgSrc}" alt="Question Image">

                    </div>

                `;

            }



            // Options

            let options = [];

            if (typeof q.options === 'string') {

                try { options = JSON.parse(q.options); } catch(e) { options = []; }

            } else {

                options = q.options || [];

            }



            // Render Options HTML

            let optionsHtml = '<div class="answers-list" id="answers-list-' + globalIndex + '">';

            options.forEach((opt, optIdx) => {

                // Added data attributes for event delegation

                optionsHtml += `

                    <div class="answer-option" 

                         data-global-index="${globalIndex}" 

                         data-opt-idx="${optIdx}" 

                         data-correct-idx="${q.correctAnswerIndex}" 

                         id="opt-${globalIndex}-${optIdx}">

                        <div class="radio-circle"></div>

                        <div class="answer-text">${opt}</div>

                        <i class="status-icon fa-solid"></i>

                    </div>

                `;

            });

            optionsHtml += '</div>';



            questionDiv.innerHTML = `

                <div class="question-number">Հարց ${globalIndex + 1}</div>

                ${imageHtml}

                <div class="question-text"><h2>${q.question}</h2></div>

                ${optionsHtml}

            `;



            els.container.appendChild(questionDiv);

            

            // Restore state

            if (userAnswers[globalIndex]) {

                restoreAnswerState(globalIndex, userAnswers[globalIndex], q.correctAnswerIndex);

            }

        });

    }



    function checkAnswer(globalIndex, selectedIdx, correctAnswerIndex) {

        if (userAnswers[globalIndex]) return; 



        let correctIdx = Number(correctAnswerIndex) - 1;

        

        // Validation: Check if correctIdx is within bounds of available options

        const answersList = document.getElementById(`answers-list-${globalIndex}`);

        let isDataInvalid = false;

        

        if (answersList) {

            const optionsCount = answersList.children.length;

            if (Number.isNaN(correctIdx) || correctIdx < 0 || correctIdx >= optionsCount) {

                console.warn(`Question ${globalIndex}: Invalid correctAnswerIndex ${correctAnswerIndex} for ${optionsCount} options. Defaulting to user selection.`);

                isDataInvalid = true;

            }

        }



    

        const isCorrect = isDataInvalid ? true : (selectedIdx === correctIdx);

        

        if (isDataInvalid) {

            correctIdx = selectedIdx; 

        }



        userAnswers[globalIndex] = {

            selectedIdx: selectedIdx,

            isCorrect: isCorrect

        };

        

        saveProgressDB(userAnswers);



        updateUIForAnswer(globalIndex, selectedIdx, correctIdx, isCorrect);



        if (totalQuestions > 0 && Object.keys(userAnswers).length === totalQuestions) {

            finishTest();

        }

    }



    function updateUIForAnswer(globalIndex, selectedIdx, correctIdx, isCorrect) {

        const answersList = document.getElementById(`answers-list-${globalIndex}`);

        if(!answersList) return;

        

        const options = answersList.children;



        // Ultimate Failsafe: If marked wrong (!isCorrect) but the "correct" answer 

        // doesn't exist (options[correctIdx] is missing), then the question data is broken.

        // In this case, we force it to be CORRECT to avoid showing "Red only" to the user.

        if (!isCorrect && !options[correctIdx]) {

            console.warn(`Question ${globalIndex}: Marked wrong but correctIdx ${correctIdx} is invalid. Treating as correct.`);

            isCorrect = true;

            correctIdx = selectedIdx;

        }

        

        // Highlight correct

        if (options[correctIdx]) {

            options[correctIdx].classList.add('correct');

            options[correctIdx].querySelector('.status-icon').classList.add('fa-circle-check');

        }

        

        // Highlight wrong if needed

        if (!isCorrect) {

            if (options[selectedIdx]) {

                options[selectedIdx].classList.add('wrong');

                options[selectedIdx].querySelector('.status-icon').classList.add('fa-circle-xmark');

            }

        }



        // Disable all options for this question

        Array.from(options).forEach(opt => {

            opt.classList.add('disabled');

        });

    }



    function restoreAnswerState(globalIndex, answerData, correctAnswerIndex) {

        let correctIdx = Number(correctAnswerIndex) - 1;



        // Fix: If saved state is correct, force UI to show selected as correct

        if (answerData.isCorrect) {

            correctIdx = answerData.selectedIdx;

        }



        // Validation for revisiting: If question data is broken (invalid correctIdx),

        // treat the saved answer as correct visually to avoid "Red with no Green" confusion.

        const answersList = document.getElementById(`answers-list-${globalIndex}`);

        if (answersList) {

             const optionsCount = answersList.children.length;

             if (Number.isNaN(correctIdx) || correctIdx < 0 || correctIdx >= optionsCount) {

                 // Invalid question data -> Show as Correct (Green)

                 updateUIForAnswer(globalIndex, answerData.selectedIdx, answerData.selectedIdx, true);

                 return;

             }

        }



        updateUIForAnswer(globalIndex, answerData.selectedIdx, correctIdx, answerData.isCorrect);

    }



    function openImageModal(src) {

        if (els.imageModal && els.modalImage) {

            els.modalImage.src = src;

            els.imageModal.show();

        }

    }



    function finishTest() {

        const answeredCount = Object.keys(userAnswers).length;

        const correct = Object.values(userAnswers).filter(a => a.isCorrect).length;

        const wrongAnswered = Object.values(userAnswers).filter(a => !a.isCorrect).length; 

        const unanswered = totalQuestions - answeredCount;

        const wrongTotal = wrongAnswered + unanswered;



        const score = totalQuestions > 0 ? Math.round((correct / totalQuestions) * 100) : 0;

        const timeSpentSeconds = Math.floor((Date.now() - startTime) / 1000); 

        

        const minutes = Math.floor(timeSpentSeconds / 60);

        const seconds = timeSpentSeconds % 60;

        const timeString = `${minutes}ր ${seconds}վ`;



        if (els.correctCount) els.correctCount.innerText = correct;

        if (els.wrongCount) els.wrongCount.innerText = wrongTotal; 

        

        if (els.scorePercent) els.scorePercent.innerText = score;

        if (els.timeSpentBadge) els.timeSpentBadge.innerText = timeString;



        const circle = document.getElementById('scoreCircle');

        if(circle) {

            circle.className = 'score-circle mb-4'; 

            if (score >= 90) circle.classList.add('high');

            else if (score >= 50) circle.classList.add('medium');

            else circle.classList.add('low');

        }



        if (els.resultModal) els.resultModal.show();



        const resultData = {

            groupId: groupData.id,

            score: score,

            correct_count: correct,

            wrong_count: wrongTotal,

            time_spent: timeSpentSeconds,

            status: score >= 90 ? 'passed' : 'failed'

        };



        fetch('/api/v1/groups/submit', {

            method: 'POST',

            headers: { 'Content-Type': 'application/json' },

            body: JSON.stringify(resultData)

        }).then(res => res.json())

            .then(data => {

                // console.log('Saved:', data);

                // Clear progress from DB

                saveProgressDB({});

            })

            .catch(err => console.error('Error saving result:', err));

    }



    // Start

    init();

});
document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.filter-btn');
    const cards = document.querySelectorAll('.test-card');

    buttons.forEach(btn => {
        btn.addEventListener('click', () => {
            // Update active state
            buttons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            const filter = btn.getAttribute('data-filter');

            cards.forEach(card => {
                const col = card.closest('.group-col');
                if (!col) return;

                if (filter === 'all' || card.dataset.status === filter) {
                    col.style.display = '';
                } else {
                    col.style.display = 'none';
                }
            });
        });
    });

    // Reset Groups Logic
    const resetBtn = document.getElementById('resetGroupsBtn');
    if (resetBtn) {
        resetBtn.addEventListener('click', async () => {
            const confirmed = await showModalConfirm({
                title: 'Զրոյացնել արդյունքները', 
                message: 'Վստա՞հ եք, որ ցանկանում եք զրոյացնել ԽՄԲԵՐԻ բոլոր արդյունքները։ Այս գործողությունը անդարձելի է։',
                confirmText: 'Զրոյացնել',
                cancelText: 'Չեղարկել'
            });
            
            if (!confirmed) return;
            
            try {
                // Get CSRF token from meta tag or cookie
                const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content ||
                                  document.cookie.split('; ').find(row => row.startsWith('_csrf='))?.split('=')[1];
                
                const res = await fetch('/api/v1/user/reset-groups', {
                    method: 'POST',
                    headers: {
                        'x-csrf-token': csrfToken || ''
                    }
                });
                const data = await res.json();
                if(data.status === 'success') {
                    showNotification(data.message || 'Խմբերի արդյունքները զրոյացվեցին', 'success');
                    setTimeout(() => window.location.reload(), 1000);
                } else {
                    showNotification(data.message || 'Սխալ տեղի ունեցավ', 'error');
                }
            } catch(e) {
                // console.error(e);
                showNotification('Սերվերի սխալ', 'error');
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const currentPath = window.location.pathname;
    const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
    
    navLinks.forEach(link => {
        const href = link.getAttribute('href');
        // Remove active class first
        link.classList.remove('active');
        
        // Exact match for root or other pages
        if (href === currentPath) {
            link.classList.add('active');
        } 
        else if (href !== '/' && href !== '#' && currentPath.startsWith(href)) {
             link.classList.add('active');
        }
    });

    const navIcon = document.getElementById("hamburgetButton");

    navIcon.addEventListener("click", function () {
        this.classList.toggle("open");
    });
});

 document.addEventListener('DOMContentLoaded', () => {
     const navItems = document.querySelectorAll('.mobile_navigation .nav-item');
     const indicator = document.querySelector('.mobile_navigation .nav-indicator');

     function updateIndicator(item) {
         const itemLeft = item.offsetLeft;
         const itemWidth = item.offsetWidth;
         const indicatorWidth = 50;

         const targetLeft = itemLeft + (itemWidth / 2) - (indicatorWidth / 2);
         indicator.style.left = `${targetLeft}px`;
     }

     // Set active item based on current URL
    const currentPath = window.location.pathname;
    navItems.forEach(item => {
        const href = item.getAttribute('href');

        if (href === currentPath || (href !== '/' && currentPath.startsWith(href))) {
            navItems.forEach(nav => nav.classList.remove('active'));
            item.classList.add('active');
        }
    });

    // Initialize position for the active item
    const activeItem = document.querySelector('.mobile_navigation .nav-item.active');
    if (activeItem) {
        // Disable transition initially to prevent sliding animation on page load
        indicator.style.transition = 'none';
        
        // Update position immediately
        updateIndicator(activeItem);

        // Make visible and restore transition
        // We need a double RequestAnimationFrame or a small timeout to ensure the style change (position) has applied
        // before we change opacity and transition
        requestAnimationFrame(() => {
            indicator.style.opacity = '1';
            
            // Restore transition after a short delay
            setTimeout(() => {
                indicator.style.transition = '';
            }, 100);
        });
    }

    navItems.forEach(item => {
        item.addEventListener('click', (e) => {
            // If it's a modal trigger, don't do the delay navigation
            if (item.hasAttribute('data-bs-toggle')) {
                // Prevent default anchor jump if it's a link
                if (item.tagName === 'A') e.preventDefault();
                return;
            }

            e.preventDefault(); 
            const href = item.getAttribute('href');

            // Remove active class from all
            navItems.forEach(nav => nav.classList.remove('active'));

            // Add active class to clicked
            item.classList.add('active');

            // Update indicator position
            updateIndicator(item);

            // Wait 1 second (1000ms) before navigating
            setTimeout(() => {
                window.location.href = href;
            }, 1000);
        });
    });

     // Update on resize to keep correct position
     window.addEventListener('resize', () => {
         const currentActive = document.querySelector('.mobile_navigation .nav-item.active');
         if (currentActive) {
             updateIndicator(currentActive);
         }
     });
 });
class NotificationManager {
    constructor(containerSelector = null) {
        this.container = containerSelector
            ? document.querySelector(containerSelector)
            : null;
        this.max = 5;
        this.confirmOpen = false;
        this.init();
    }

    init() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'notification-container';
            document.body.appendChild(this.container);
        }
    }

    show(message, type = 'info', duration = 5000) {
        if (typeof duration !== 'number' || isNaN(duration)) {
            duration = 5000;
        }

        let icon = 'fa-circle-info';
        let color = '#11CDEF';
        let bg = '#fff';
        if (type === 'success') {
            icon = 'fa-circle-check';
            color = '#2DCE89';
            bg = '#ffff';
        } else if (type === 'danger' || type === 'error') {
            icon = 'fa-circle-exclamation';
            color = '#F5365C';
            bg = '#fff';
        } else if (type === 'warning') {
            icon = 'fa-triangle-exclamation';
            color = '#FB6340';
            bg = '#fff';
        }

        const notification = document.createElement('div');
        notification.className = `notification notification-${type}`;
        notification.style.zIndex = '9999'; 
        notification.innerHTML = `
            <div class="notification-content">
                <i class="fa-solid ${icon} notification-icon"></i>
                <span class="notification-message">${message}</span>
                <button class="notification-close">&times;</button>
            </div>
            <div class="notification-progress"></div>
        `;

        notification.style.borderLeftColor = color;
        notification.style.background = bg;
        const iconEl = notification.querySelector('.notification-icon');
        if (iconEl) iconEl.style.color = color;

        notification.querySelector('.notification-close').addEventListener('click', () => {
            this.hide(notification);
        });

        // Auto-hide (staggered): 3s base + 400ms per existing item
        const idx = this.container.children.length; // before append
        const effectiveDuration = Math.max(0, duration + idx * 400);
        
        const progressBar = notification.querySelector('.notification-progress');
        if (progressBar) {
            progressBar.style.animationName = 'notificationProgress';
            progressBar.style.animationDuration = `${effectiveDuration}ms`;
            progressBar.style.animationTimingFunction = 'linear';
            progressBar.style.animationFillMode = 'forwards';
        }

        const timeoutId = setTimeout(() => this.hide(notification), effectiveDuration);

        // Remove from DOM
        notification.addEventListener('transitionend', () => {
            if (!notification.classList.contains('show') && notification.parentElement) {
                notification.parentElement.removeChild(notification);
                clearTimeout(timeoutId);
            }
        });

        while (this.container.children.length >= this.max) {
            if (this.container.firstElementChild) this.container.removeChild(this.container.firstElementChild);
        }
        this.container.appendChild(notification);

        // Animate in
        requestAnimationFrame(() => notification.classList.add('show'));
    }

    hide(notification) {
        notification.classList.remove('show');
        setTimeout(() => {
            if (notification && notification.parentElement && !notification.classList.contains('show')) {
                notification.parentElement.removeChild(notification);
            }
        }, 350);
    }

    confirm({ title = 'Հաստատում', message = '', confirmText = 'Այո', cancelText = 'Չեղարկել', timeout = 0 } = {}) {
        if (this.confirmOpen) return Promise.resolve(false);
        this.confirmOpen = true;
        return new Promise((resolve) => {
            const notification = document.createElement('div');
            notification.className = 'notification notification-confirm';
            notification.style.zIndex = '9999';
            notification.innerHTML = `
                <div class="notification-content">
                    <div class="notification-title">${title}</div>
                    <div class="notification-message">${message}</div>
                    <div class="notification-actions">
                        <button class="btn btn-sm btn-secondary notification-cancel">${cancelText}</button>
                        <button class="btn btn-sm btn-primary notification-confirm-btn">${confirmText}</button>
                    </div>
                </div>
            `;

            const onCleanup = () => {
                this.confirmOpen = false;
                this.hide(notification);
            };
            let autoTimer;
            if (timeout && timeout > 0) {
                autoTimer = setTimeout(() => {
                    resolve(false);
                    onCleanup();
                }, timeout);
            }

            notification.querySelector('.notification-cancel').addEventListener('click', () => {
                if (autoTimer) clearTimeout(autoTimer);
                resolve(false);
                onCleanup();
            });
            notification.querySelector('.notification-confirm-btn').addEventListener('click', () => {
                if (autoTimer) clearTimeout(autoTimer);
                resolve(true);
                onCleanup();
            });

            while (this.container.children.length >= this.max) {
                if (this.container.firstElementChild) this.container.removeChild(this.container.firstElementChild);
            }
            this.container.appendChild(notification);
            requestAnimationFrame(() => notification.classList.add('show'));
        });
    }
}

// Singleton pattern for app-wide use
const notifications = new NotificationManager();

function showNotification(message, type = 'info', duration = 5000) {
    notifications.show(message, type, duration);
}

function showConfirm(options) {
    return notifications.confirm(options);
}

function showModalConfirm({ title = 'Հաստատում', message = '', confirmText = 'Այո', cancelText = 'Չեղարկել' } = {}) {
    return new Promise((resolve) => {
        if (notifications.confirmOpen) return resolve(false);
        notifications.confirmOpen = true;

        const overlay = document.createElement('div');
        overlay.className = 'confirm-modal-overlay';

        const modal = document.createElement('div');
        modal.className = 'confirm-modal';
        modal.innerHTML = `
            <div class="confirm-header">${title}</div>
            <div class="confirm-body">${message}</div>
            <div class="confirm-actions">
                <button class="btn btn-sm text-white btn-danger confirm-cancel">${cancelText}</button>
                <button class="btn btn-sm text-white btn-success confirm-ok">${confirmText}</button>
            </div>
        `;

        overlay.appendChild(modal);
        document.body.appendChild(overlay);

        // Add class to trigger animation after a small delay
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                overlay.classList.add('open');
            });
        });

        const cleanup = () => {
            notifications.confirmOpen = false;
            overlay.classList.remove('open');
            
            const removeOverlay = () => {
                if (overlay && overlay.parentElement) overlay.parentElement.removeChild(overlay);
            };

            overlay.addEventListener('transitionend', removeOverlay, { once: true });
            
            setTimeout(removeOverlay, 400);
        };

        modal.querySelector('.confirm-cancel').addEventListener('click', () => {
            resolve(false);
            cleanup();
        });
        modal.querySelector('.confirm-ok').addEventListener('click', () => {
            resolve(true);
            cleanup();
        });
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                resolve(false);
                cleanup();
            }
        });
        document.addEventListener('keydown', function esc(e) {
            if (e.key === 'Escape') {
                document.removeEventListener('keydown', esc);
                resolve(false);
                cleanup();
            }
        });
    });
}


class PaginationManager {
    constructor({ container, itemsPerPage = 30, urlParam = "page" }) {
        this.container = container;
        this.itemsPerPage = itemsPerPage;
        this.urlParam = urlParam;

        const params = new URLSearchParams(location.search);
        this.currentPage = parseInt(params.get(this.urlParam)) || 1;

        this.totalItems = 0;
        this.onPageChange = () => {};
    }
    setTotal(total) {
        this.totalItems = total;
    }

    setPage(page) {
        if (page === this.currentPage) return;
        this.currentPage = page;
        this._writeURL(page);
        this.onPageChange(page);
    }

    get totalPages() {
        return Math.ceil(this.totalItems / this.itemsPerPage);
    }

    _writeURL(page) {
        const url = new URL(window.location);
        if (page > 1) {
            url.searchParams.set(this.urlParam, page);
        } else {
            url.searchParams.delete(this.urlParam);
        }

        history.replaceState({}, "", url);
    }

    render() {
        if(!this.container) return;

        const totalPages = this.totalPages;

        if (totalPages === 0) {
            this.currentPage = 1;
            this.container.innerHTML = "";
            return;
        }
        if (this.currentPage > totalPages) {
            this.currentPage = totalPages;
        }

        if (this.currentPage < 1) {
            this.currentPage = 1;
        }

        this.container.innerHTML = "";

        if (totalPages <= 1) return;

        const nav = document.createElement("nav");
        const ul = document.createElement("ul");
        ul.className = "pagination justify-content-center";

        const addBtn = (label, page, disabled, isActive = false) => {
            const li = document.createElement("li");
            li.className = `page-item ${disabled ? "disabled" : ""} ${isActive ? "active" : ""}`;

            const btn = document.createElement("button");
            btn.className = "page-link";
            btn.innerHTML = label;

            if (!disabled && !isActive) {
                btn.onclick = (e) => {  
                    e.preventDefault();
                    this.setPage(page);
                    this.render();
                };
            }

            li.appendChild(btn);
            ul.appendChild(li);
        };

        const addEllipsis = () => {
            const li = document.createElement("li");
            li.className = "page-item disabled";
            li.innerHTML = '<span class="page-link">...</span>';
            ul.appendChild(li);
        };

        // Previous button
        addBtn(`<i class="bi bi-chevron-left"></i>`, this.currentPage - 1, this.currentPage === 1);

        // Page numbers
        const maxVisible = 5;
        
        if (totalPages <= 7) {
            // Show all if few pages
            for (let i = 1; i <= totalPages; i++) {
                addBtn(i, i, false, i === this.currentPage);
            }
        } else {
            // Always show first page
            addBtn(1, 1, false, 1 === this.currentPage);

            if (this.currentPage > 3) {
                addEllipsis();
            }

            // Calculate range
            let start = Math.max(2, this.currentPage - 1);
            let end = Math.min(totalPages - 1, this.currentPage + 1);

            // Adjust if near start
            if (this.currentPage <= 3) {
                end = 4;
            }

            // Adjust if near end
            if (this.currentPage >= totalPages - 2) {
                start = totalPages - 3;
            }

            for (let i = start; i <= end; i++) {
                addBtn(i, i, false, i === this.currentPage);
            }

            if (this.currentPage < totalPages - 2) {
                addEllipsis();
            }

            // Always show last page
            addBtn(totalPages, totalPages, false, totalPages === this.currentPage);
        }

        // Next button
        addBtn(`<i class="bi bi-chevron-right"></i>`, this.currentPage + 1, this.currentPage === totalPages);

        nav.appendChild(ul);
        this.container.appendChild(nav);
    }

}
class Questions {
    constructor(object, containerSelector) {
        this.object = object;
        this.container = document.querySelector(containerSelector);
        this.correctAnswers = object.map(item => item.correctAnswerIndex);
        this.answeredQuestions = new Set();
        this.score = 0;
        this.resultBox = document.createElement('div');
        this.resultBox.id = 'resultBox';
        this.init();
    }

    generateAnswer(option, i, qIndex) {
        return `
            <li class="question_answer" data-question="${qIndex}" data-index="${i}">
              <span class="count">0${i + 1}</span> ${option}
            </li>`;
    }

    renderQuestionCard(item, index) {
        let answersHTML = '';
        let options = this.parseOptions(item.options);

        options.forEach((option, i) => {
            answersHTML += this.generateAnswer(option, i, index);
        });

        let i = index + 1;
        let image = {
            img: ''
        };
        // console.log(item.files)

        if (item.files) {
            let foundImage = item.files.find(file => file.name_used === 'question_img');
            if (foundImage) {
                image = {
                    img: `/client/images/questions/large/${foundImage.name}.${foundImage.ext}`
                };
            } else {
                image = {
                    img: `/client/images/404.jpg`
                };
            }
        }

        return `
            <div class="questionCard">
              <div class="badge">${i < 10 ? "0" + i : i}</div>
              <div class="image" id="lightgallery">
                <a href="${image.img}" class="gallery_item scroll_animate">
                    <img src="${image.img}" />
                </a>
              </div>
              <div class="card_body">
                <h3 class="title">${item.question}</h3>
                <ul class="question_answers">${answersHTML}</ul>
              </div>
            </div>`;
    }

    parseOptions(options) {
        try {
            if (typeof options === "string") {
                return JSON.parse(options);
            }
            return options;
        } catch (e) {
            return [];
        }
    }

    renderQuestions() {
        this.container.innerHTML = ""; 
        this.object.forEach((item, index) => {
            this.container.innerHTML += this.renderQuestionCard(item, index);
        });

        if (this.container) this.container.appendChild(this.resultBox);
    }

    handleClicks() {
        const allAnswers = document.querySelectorAll('.question_answer');

        allAnswers.forEach(answer => {
            answer.addEventListener('click', () => {
                const qIndex = parseInt(answer.dataset.question);
                const selected = parseInt(answer.dataset.index);
                const correct = this.correctAnswers[qIndex];

                const allInQuestion = answer.parentElement.querySelectorAll('.question_answer');
                if (this.answeredQuestions.has(qIndex)) return;

                allInQuestion.forEach((ans, i) => {
                    ans.style.pointerEvents = 'none';

                    if (i === correct) {
                        ans.style.backgroundColor = '#d4edda';
                        ans.style.color = '#155724';
                    }

                    if (i === selected && selected !== correct) {
                        ans.style.backgroundColor = '#f8d7da';
                        ans.style.color = '#721c24';
                    }
                });

                this.answeredQuestions.add(qIndex);
                if (selected === correct) this.score++;

                if (this.answeredQuestions.size === this.object.length) {
                    this.resultBox.innerHTML = `
                        <div class="result">
                          <i class="fa-solid fa-circle-check" style="font-size: 20px; color: #00DE3B"></i> 
                          Դու պատասխանել ես ${this.object.length}-ից <strong>${this.score}</strong> ճիշտ հարցի։
                        </div>`;
                }
            });
        });
    }

    init() {
        if (!this.container) return;
        this.renderQuestions();
        this.handleClicks();
    }
}

const selectQuestionTest = document.querySelector('#select_tests');
const selectQuestionGroup = document.querySelector('#select_groups');

(async function () {
    if (selectQuestionTest) {
        const tests = await doAxios(`/api/v1/tests`);
        tests.data.tests.forEach(test => {
            selectQuestionTest.innerHTML += `<option value="${test.id}">${test.title}-${test.number}</option>`;
        });
    }

    if (selectQuestionGroup) {
        const groups = await doAxios(`/api/v1/groups`);
        groups.data.groups.forEach(group => {
            selectQuestionGroup.innerHTML += `<option value="${group.id}">${group.slug}</option>`;
        });
    }
})();

// event handler
async function handleSelectChange(e) {
    const selectedValue = e.target.value;
    const selectedName = e.target.name;

    if (selectedName === 'selected_test') {
        if (selectedValue === '*') {
            new Questions([], '.tests_page .question_card');
            return;
        }
        const test = await doAxios(`/api/v1/tests/${selectedValue}`);
        // console.log(test)
        new Questions(test.data.tests.questions, '.tests_page .question_card');
    } else if (selectedName === 'selected_groups') {

        if (selectedValue === '*') {
            new Questions([], '.groups_page .question_card');
            return;
        }
        const group = await doAxios(`/api/v1/groups/${selectedValue}`);
        new Questions(group.data.group.questions, '.groups_page .question_card');
    }
}

// Event listeners
if (selectQuestionTest) {
    selectQuestionTest.addEventListener('change', handleSelectChange);
}
if (selectQuestionGroup) {
    selectQuestionGroup.addEventListener('change', handleSelectChange);
}
document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('resetPasswordForm');
    if (!form) return;

    const token = form.dataset.token;
    const togglePasswordBtn = document.getElementById('togglePassword');
    const passwordInput = document.getElementById('password');

    // Toggle password visibility
    if (togglePasswordBtn && passwordInput) {
        togglePasswordBtn.addEventListener('click', function () {
            const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
            passwordInput.setAttribute('type', type);
            this.querySelector('i').classList.toggle('fa-eye');
            this.querySelector('i').classList.toggle('fa-eye-slash');
        });
    }

    form.addEventListener('submit', async function (e) {
        e.preventDefault();

        if (!form.checkValidity()) {
            e.stopPropagation();
            form.classList.add('was-validated');
            return;
        }

        const password = document.getElementById('password').value;
        const passwordConfirm = document.getElementById('passwordConfirm').value;

        if (password !== passwordConfirm) {
            showNotification('Գաղտնաբառերը չեն համընկնում', 'error');
            return;
        }

        try {
            const submitBtn = form.querySelector('button[type="submit"]');
            const originalText = submitBtn.innerHTML;
            submitBtn.disabled = true;
            submitBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Կատարվում է...';

            const response = await doAxios(`/api/v1/user/resetPassword/${token}`, 'POST', {
                password
            });

            if (response.success) {
                showNotification('Գաղտնաբառը հաջողությամբ փոխվեց', 'success');
                setTimeout(() => {
                    window.location.href = '/';
                }, 1500);
            } else {
                showNotification(response.message || 'Սխալ տեղի ունեցավ', 'error');
                submitBtn.disabled = false;
                submitBtn.innerHTML = originalText;
            }
        } catch (err) {
            // console.error(err);
            showNotification('Սխալ տեղի ունեցավ', 'error');
            const submitBtn = form.querySelector('button[type="submit"]');
            submitBtn.disabled = false;
            submitBtn.innerHTML = 'Պահպանել գաղտնաբառը';
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.reviews-swiper')) {
        new Swiper('.reviews-swiper', {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                }
            }
        });
    }

    const progressBars = document.querySelectorAll('.review-progress-bar');
    progressBars.forEach(bar => {
        const width = bar.getAttribute('data-width');
        if (width) {
            setTimeout(() => {
                bar.style.width = width + '%';
            }, 100);
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // 1. Data from DOM
    const testRoot = document.getElementById('testRoot');

    if (!testRoot) return;

    let testData = {};

    try {
        testData = JSON.parse(testRoot.dataset.test || '{}');

    } catch (e) {

    }

    const questions = testData.questions || [];

    

    if (questions.length === 0) {

        showNotification('Այս թեստում հարցեր չկան', 'warning');

        return;

    }


    // 2. State

    let currentQuestionIndex = 0;
    let userAnswers = new Array(questions.length).fill(null); 
    let timeLeft = 30 * 60;

    let startTime = Date.now();
    let timerInterval;


    // 3. DOM Elements

    const els = {

        testTitle: document.getElementById('testTitle'),
        timer: document.getElementById('timer'),
        progressText: document.getElementById('progressText'),
        progressBar: document.getElementById('progressBar'),
        questionImage: document.getElementById('questionImage'),
        imageWrapper: document.getElementById('imageWrapper'),
        questionText: document.getElementById('questionText'),
        answersList: document.getElementById('answersList'),
        nextBtn: document.getElementById('nextBtn'),
        navGrid: document.getElementById('navGrid'),
        resultModal: typeof bootstrap !== 'undefined' ? new bootstrap.Modal(document.getElementById('resultModal')) : null,
        correctCount: document.getElementById('correctCount'),
        wrongCount: document.getElementById('wrongCount'),
        timeSpentBadge: document.getElementById('timeSpentBadge'),
        scorePercent: document.getElementById('scorePercent')

    };


    // 4. Initialization
    function init() {
        startTimer();
        renderNavGrid();
        loadQuestion(0);

    }


    // 5. Event Listeners
    if (els.nextBtn) els.nextBtn.addEventListener('click', nextQuestion);

    // Image Zoom
    if (els.zoomBtn) els.zoomBtn.addEventListener('click', openImageModal)



    // Retry Button

    const btnRetry = document.getElementById('btnRetry');

    if (btnRetry) {
        btnRetry.addEventListener('click', () => {

            location.reload();
        });

    }



    // Answers List Delegation

    if (els.answersList) {

        els.answersList.addEventListener('click', (e) => {
            const optionDiv = e.target.closest('.answer-option');

            if (optionDiv && !optionDiv.classList.contains('disabled')) {
                const idx = parseInt(optionDiv.dataset.idx);
                checkAnswer(idx);

            }

        });

    }


    // Navigation Grid Delegation
    if (els.navGrid) {

        els.navGrid.addEventListener('click', (e) => {

            const item = e.target.closest('.nav-item');

            if (item) {

                const idx = parseInt(item.dataset.idx);

                loadQuestion(idx);
            }

        });

    }


    function startTimer() {
        updateTimerDisplay();

        timerInterval = setInterval(() => {
            timeLeft--;
            updateTimerDisplay();
            if (timeLeft <= 0) finishTest(true);

        }, 1000);

    }



    function updateTimerDisplay() {
        if (!els.timer) return;
        const m = Math.floor(timeLeft / 60).toString().padStart(2, '0');
        const s = (timeLeft % 60).toString().padStart(2, '0');
        els.timer.innerText = `${m}:${s}`;

    }


    function loadQuestion(index) {
        currentQuestionIndex = index;
        const q = questions[index];


        // Update Progress
        if (els.progressText) els.progressText.innerText = `Հարց ${index + 1} / ${questions.length}`;
        if (els.progressBar) els.progressBar.style.width = `${((index + 1) / questions.length) * 100}%`;


        // Update Text
        if (els.questionText) els.questionText.innerText = q.question;


        // Update Image
        if (els.imageWrapper && els.questionImage) {

            let imgSrc = '/images/no-image.png';

            if (q.files && q.files.length > 0) {
                const file = q.files[0];
                imgSrc = `/images/questions/large/${file.name}.${file.ext}`;

            }

            

            els.questionImage.src = imgSrc;
            if (els.modalImage) els.modalImage.src = imgSrc;

            // Always show wrapper to maintain height/layout consistency

            els.imageWrapper.style.display = 'block'; 

        }



        // Reset UI
        if (els.nextBtn) els.nextBtn.disabled = true;

        renderAnswers(q);

        // Update Nav Grid highlight
        updateNavGrid();

    }



    function renderAnswers(q) {

        if (!els.answersList) return;

        els.answersList.innerHTML = '';

        let options = [];

        

        // Parse options if string

        if (typeof q.options === 'string') {

            try {

                options = JSON.parse(q.options);

            } catch(e) { options = []; }

        } else {

            options = q.options || [];

        }


        let correctIdx = Number(q.correctAnswerIndex) - 1;

        // Validation: Check bounds

        if (Number.isNaN(correctIdx) || correctIdx < 0 || correctIdx >= options.length) {

             console.warn(`Question ${currentQuestionIndex}: Invalid correctAnswerIndex ${q.correctAnswerIndex}.`);

             if (userAnswers[currentQuestionIndex] && userAnswers[currentQuestionIndex].isCorrect) {
                correctIdx = userAnswers[currentQuestionIndex].selectedIdx;

             }

        }



        options.forEach((opt, idx) => {

            const btn = document.createElement('div');

            btn.className = 'answer-option';

            btn.dataset.idx = idx; 

            const isAnswered = userAnswers[currentQuestionIndex] !== null;

            

            if (isAnswered) {

                btn.classList.add('disabled');

                const userSel = userAnswers[currentQuestionIndex].selectedIdx;

                const userCorrect = userAnswers[currentQuestionIndex].isCorrect;

                if (idx === correctIdx) {

                    btn.classList.add('correct');

                } 

                if (!userCorrect && idx === userSel) {

                     btn.classList.add('wrong');

                }

            }



            btn.innerHTML = `

                <div class="radio-circle"></div>

                <div class="answer-text">${opt}</div>

                <i class="status-icon fa-solid ${idx === correctIdx ? 'fa-circle-check' : 'fa-circle-xmark'}"></i>

            `;

            els.answersList.appendChild(btn);

        });



        if (userAnswers[currentQuestionIndex] !== null && els.nextBtn) {
            els.nextBtn.disabled = false;
        }

    }


    function checkAnswer(selectedIdx) {
        if (userAnswers[currentQuestionIndex] !== null) return; // Already answered

        const q = questions[currentQuestionIndex];
        let correctIdx = Number(q.correctAnswerIndex) - 1;

        // Validation

        let optionsCount = 0;

        if(els.answersList) optionsCount = els.answersList.children.length;

        let isDataInvalid = false;

        if (Number.isNaN(correctIdx) || correctIdx < 0 || correctIdx >= optionsCount) {

             console.warn(`Question ${currentQuestionIndex}: Invalid correctAnswerIndex ${q.correctAnswerIndex}. Defaulting to user selection.`);

             isDataInvalid = true;

        }

        const isCorrect = isDataInvalid ? true : (selectedIdx === correctIdx);

        if (isDataInvalid) {
            correctIdx = selectedIdx; 

        }

        userAnswers[currentQuestionIndex] = {
            selectedIdx: selectedIdx,
            isCorrect: isCorrect

        };


        const options = els.answersList.children;

        // Highlight correct

        if (options[correctIdx]) {

            options[correctIdx].classList.add('correct');

        }

        // Highlight wrong if needed
        if (!isCorrect) {

            if (options[selectedIdx]) {

                options[selectedIdx].classList.add('wrong');
            }

        }

        Array.from(options).forEach(opt => opt.classList.add('disabled'));

        // Enable Next
        if (els.nextBtn) els.nextBtn.disabled = false;

        // Update Nav Grid
        updateNavGrid();
    }



    function nextQuestion() {
        if (currentQuestionIndex < questions.length - 1) {
            loadQuestion(currentQuestionIndex + 1);

        } else {
            // Check if all answered

            const allAnswered = userAnswers.every(ans => ans !== null);
            if (allAnswered) {
                finishTest();

            } else {
                // Find first unanswered
                const firstUnanswered = userAnswers.findIndex(ans => ans === null);

                if (firstUnanswered !== -1) {
                    showNotification('Խնդրում ենք պատասխանել բոլոր հարցերին ավարտելու համար:', 'warning');
                    loadQuestion(firstUnanswered);
                }
            }
        }
    }



    function finishTest(isTimeout = false) {
        clearInterval(timerInterval);

        const correct = userAnswers.filter(a => a && a.isCorrect).length;
        const wrong = userAnswers.filter(a => a && !a.isCorrect).length; 

        
        // Calculate time spent
        let timeText = '';

        if (isTimeout) {

            timeText = 'Ժամանակը սպառվեց';

        } else {

            const endTime = Date.now();
            const timeSpentSeconds = Math.floor((endTime - startTime) / 1000);
            const m = Math.floor(timeSpentSeconds / 60);
            const s = timeSpentSeconds % 60;
            timeText = `${m} րոպե ${s} վայրկյանում`;

        }


        // Calculate score

        const total = questions.length;

        const score = total > 0 ? Math.round((correct / total) * 100) : 0;

        if (els.correctCount) els.correctCount.innerText = correct;
        if (els.wrongCount) els.wrongCount.innerText = wrong;
        if (els.timeSpentBadge) els.timeSpentBadge.innerText = timeText;
        

        // Handle timeout badge color

        if (isTimeout && els.timeSpentBadge) {

            els.timeSpentBadge.classList.replace('bg-primary', 'bg-danger');
        }


        if (els.scorePercent) els.scorePercent.innerText = score;


        // Color circle based on score

        const circle = document.getElementById('scoreCircle');

        if(circle) {
            circle.className = 'score-circle mb-4'; 
            if (score >= 90) circle.classList.add('high');
            else if (score >= 50) circle.classList.add('medium');
            else circle.classList.add('low');
        }


        if (els.resultModal) els.resultModal.show();


        // Save result to server
        const resultData = {
            testId: testData.id,
            score: score,
            correct_count: correct,
            wrong_count: wrong,
            time_spent: isTimeout ? 30*60 : Math.floor((Date.now() - startTime) / 1000),
            status: score >= 90 ? 'passed' : 'failed'

        };


        fetch('/api/v1/tests/submit', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(resultData)

        }).then(res => res.json())

          .then(data => {

              if (data.saved) {}

          }).catch(err => {});
    }



    function renderNavGrid() {
        if (!els.navGrid) return;

        els.navGrid.innerHTML = '';
        questions.forEach((_, idx) => {

            const item = document.createElement('div');
            item.className = 'nav-item';
            item.innerText = idx + 1;
            item.dataset.idx = idx;
            item.id = `nav-item-${idx}`;
            els.navGrid.appendChild(item);

        });

    }



    function updateNavGrid() {

        if (!els.navGrid) return;

        questions.forEach((_, idx) => {

            const item = document.getElementById(`nav-item-${idx}`);

            if (!item) return;

            // Reset

            item.className = 'nav-item'; 

            if (idx === currentQuestionIndex) item.classList.add('current');

            const ans = userAnswers[idx];

            if (ans) {

                item.classList.add(ans.isCorrect ? 'correct' : 'wrong');

            }

        });

    }


    function openImageModal() {

        if (els.imageModal) els.imageModal.show();

    }


    // Start

    init();

});


document.addEventListener('DOMContentLoaded', function() {

    const buttons = document.querySelectorAll('.filter-btn');

    const cards = document.querySelectorAll('.test-card');



    buttons.forEach(btn => {

        btn.addEventListener('click', () => {

            // Update active state

            buttons.forEach(b => b.classList.remove('active'));

            btn.classList.add('active');
            const filter = btn.getAttribute('data-filter');

            cards.forEach(card => {

                const col = card.closest('.test-col');

                if (!col) return;

                if (filter === 'all' || card.dataset.status === filter) {

                    col.style.display = ''; 

                } else {

                    col.style.display = 'none';

                }

            });

        });

    });




    // Reset Tests Logic

    const resetBtn = document.getElementById('resetTestsBtn');

    if (resetBtn) {

        resetBtn.addEventListener('click', async () => {
            const confirmed = await showModalConfirm({
                title: 'Զրոյացնել արդյունքները', 
                message: 'Վստա՞հ եք, որ ցանկանում եք զրոյացնել ԹԵՍՏԵՐԻ բոլոր արդյունքները։ Այս գործողությունը անդարձելի է։',
                confirmText: 'Զրոյացնել',
                cancelText: 'Չեղարկել'

            });

          
            

            if (!confirmed) return;

            try {
                // Get CSRF token from meta tag or cookie
                const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content ||
                    document.cookie.split('; ').find(row => row.startsWith('_csrf='))?.split('=')[1];
                
                const res = await fetch('/api/v1/user/reset-tests', {
                    method: 'POST',
                    headers: {
                        'x-csrf-token': csrfToken || ''
                    }
                });

                const data = await res.json();

                if(data.status === 'success') {

                    showNotification(data.message || 'Թեստերի արդյունքները զրոյացվեցին', 'success');

                    setTimeout(() => window.location.reload(), 1000);

                } else {

                    showNotification(data.message || 'Սխալ տեղի ունեցավ', 'error');

                }

            } catch(e) {
                showNotification('Սերվերի սխալ', 'error');
            }

        });
    }
});


document.addEventListener('DOMContentLoaded', function () {
    // Handle User Profile Update
    const profileForm = document.querySelector('.form-user-update');
    if (profileForm) {
        profileForm.addEventListener('submit', async function (e) {
            e.preventDefault();
            if (!validateBootstrap(this)) return;

            const btn = this.querySelector('button[type="submit"]');
            const originalText = btn.innerHTML;
            setFormLoading(this, true);
            btn.innerHTML = 'Պահպանվում է...';

            const formData = new FormData(this);
            const data = Object.fromEntries(formData.entries());

            const result = await doAxios('/api/v1/user/updateme', 'PATCH', data);

            setFormLoading(this, false);
            btn.innerHTML = originalText;

            if (result.success) {
                handlerNotify('Տվյալները հաջողությամբ թարմացվեցին', 'success');
                setTimeout(() => window.location.reload(), 500);
            } else {
                handlerNotify(result.message || 'Սխալ տեղի ունեցավ', 'danger');
            }
        });
    }

    // Handle Password Update (Applies to both forms)
    const passwordForms = document.querySelectorAll('.form-password-update');
    passwordForms.forEach(form => {
        form.addEventListener('submit', async function (e) {
            e.preventDefault();
            if (!validateBootstrap(this)) return;

            const btn = this.querySelector('button[type="submit"]');
            const originalText = btn.innerHTML;
            setFormLoading(this, true);
            btn.innerHTML = 'Խնդրում ենք սպասել...';

            const formData = new FormData(this);
            const data = Object.fromEntries(formData.entries());

            const result = await doAxios('/api/v1/user/updateMyPassword', 'PATCH',
                data);

            setFormLoading(this, false);
            btn.innerHTML = originalText;

            if (result.success) {
                handlerNotify('Գաղտնաբառը հաջողությամբ թարմացվեց', 'success');
                this.reset();
                // Close modal if open
                const modalEl = document.getElementById('changePasswordModal');
                const modal = bootstrap.Modal.getInstance(modalEl);
                if (modal) modal.hide();
            } else {
                handlerNotify(result.message || 'Սխալ տեղի ունեցավ', 'danger');
            }
        });
    });

    // Payment Tab Auto-Exit Logic (2 minutes)
    const paymentTabBtn = document.getElementById('payment-tab');
    const overviewTabBtn = document.getElementById('overview-tab');
    let paymentTimer = null;

    if (paymentTabBtn && overviewTabBtn) {
        // When payment tab is shown
        paymentTabBtn.addEventListener('shown.bs.tab', function () {
            if (paymentTimer) clearTimeout(paymentTimer);
            // console.log('Payment timer started (2 mins)');
            // Set 2 minutes (120000ms) timer
            paymentTimer = setTimeout(() => {
                // console.log('Timer expired, switching to overview');
                // Switch back to overview
                overviewTabBtn.click();
            }, 120000);
        });

        const allTabs = document.querySelectorAll('[data-bs-toggle="tab"]');
        allTabs.forEach(tab => {
            if (tab.id !== 'payment-tab') {
                tab.addEventListener('show.bs.tab', function () {
                    if (paymentTimer) {
                        // console.log('Payment timer cleared');
                        clearTimeout(paymentTimer);
                        paymentTimer = null;
                    }
                });
            }
        });
    }

    // Handle Review Logic
    const reviewForm = document.getElementById('profileReviewForm');
    if (reviewForm) {
        // Star Rating Interaction (Using Wrappers for FA SVG compatibility)
        const starsContainer = reviewForm.querySelector('.rating-stars');
        const wrappers = reviewForm.querySelectorAll('.star-wrapper');
        const ratingInput = document.getElementById('ratingInput');
        const ratingText = document.getElementById('ratingText');

        if (starsContainer) {
            let currentRating = 0;

            const updateStars = (value) => {
                wrappers.forEach(w => {
                    const starValue = parseInt(w.dataset.value);
                    let solid = w.querySelector('.fa-solid, [data-prefix="fas"]');
                    let regular = w.querySelector('.fa-regular, [data-prefix="far"]');
                    
                    if (!solid || !regular) {
                        const icons = w.querySelectorAll('i, svg');
                        if (icons.length >= 2) {
                            solid = icons[0];
                            regular = icons[1];
                        }
                    }

                    if (solid && regular) {
                        if (starValue <= value) {
                            solid.classList.remove('d-none');
                            solid.style.display = 'inline-block';
                            
                            regular.classList.add('d-none');
                            regular.style.display = 'none';
                        } else {
                            solid.classList.add('d-none');
                            solid.style.display = 'none';
                            
                            regular.classList.remove('d-none');
                            regular.style.display = 'inline-block';
                        }
                    }
                });
            };

            starsContainer.addEventListener('click', function (e) {
                const wrapper = e.target.closest('.star-wrapper');
                if (!wrapper) return;

                const value = parseInt(wrapper.dataset.value);
                currentRating = value;
                ratingInput.value = value;
                
                updateStars(currentRating);
                
                ratingText.textContent = `Գնահատական՝ ${value}/5`;
                ratingText.classList.add('text-warning', 'fw-bold');
                
                // Add a small animation pulse
                wrapper.style.transform = 'scale(1.3)';
                setTimeout(() => wrapper.style.transform = 'scale(1.2)', 200);
            });

            // Hover effects
            starsContainer.addEventListener('mouseover', function(e) {
                const wrapper = e.target.closest('.star-wrapper');
                if (!wrapper) return;
                
                const value = parseInt(wrapper.dataset.value);
                updateStars(value);
                
                // Scale effect
                 wrappers.forEach(w => {
                    if (parseInt(w.dataset.value) <= value) {
                        w.style.transform = 'scale(1.2)';
                    } else {
                        w.style.transform = 'scale(1)';
                    }
                 });
            });

            starsContainer.addEventListener('mouseleave', function(e) {
                updateStars(currentRating);
                wrappers.forEach(w => w.style.transform = 'scale(1)');
            });
        }

        // Form Submission
        reviewForm.addEventListener('submit', async function(e) {
            e.preventDefault();
            
            const rating = ratingInput.value;
            if (!rating) {
                handlerNotify('Խնդրում ենք ընտրել գնահատականը (աստղերը)', 'warning');
                return;
            }

            const btn = this.querySelector('button[type="submit"]');
            const originalText = btn.innerHTML;
            setFormLoading(this, true);
            btn.innerHTML = 'Ուղարկվում է...';

            const formData = new FormData(this);
            const data = Object.fromEntries(formData.entries());

            const result = await doAxios('/api/v1/review', 'POST', data);

            setFormLoading(this, false);
            btn.innerHTML = originalText;

            if (result.success) {
                handlerNotify('Շնորհակալություն ձեր կարծիքի համար', 'success');
                setTimeout(() => window.location.reload(), 1000);
            } else {
                handlerNotify(result.message || 'Սխալ տեղի ունեցավ', 'danger');
            }
        });
    }
});

(function scrollAnimation() {

    function callback(entries) {

        entries.forEach(entry => {

            const el = entry.target;

            if (!el.dataset.saInit) {

                el.style.willChange = 'transform, opacity';

                el.style.transition = 'transform 0.28s ease-out, opacity 0.28s ease-out';

                el.dataset.saInit = '1';

            }

            if (entry.isIntersecting) {

                const t = Math.max(0, 1 - entry.intersectionRatio);

                el.style.transform = `translateY(${t * 80}px)`;

                el.style.opacity = String(entry.intersectionRatio);

            } else {

                el.style.transform = 'translateY(80px)';

                el.style.opacity = '0';

            }

        });

    }



    const options = { threshold: [0, 0.25, 0.5, 0.75, 1] };

    const observer = new IntersectionObserver(callback, options);

    document.querySelectorAll('.scroll_animate').forEach(el => {

        el.style.transform = 'translateY(80px)';

        el.style.opacity = '0';

        observer.observe(el);

    });

})();



// Bootstrap input falidation

function validateBootstrap(form) {

    'use strict';

    let isValid = true;



    form.querySelectorAll('input, textarea').forEach(input => {

        input.value = input.value.trim();

        if (!input.checkValidity()) isValid = false;

    });



    // Bootstrap validation

    if (!form.checkValidity()) {

        isValid = false;

    }



    form.classList.add('was-validated');

    return isValid;

}



async function doAxios(url, method = 'GET', data = {}) {

    try {

        // Get CSRF token from meta tag or cookie

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content ||

                          document.cookie.split('; ').find(row => row.startsWith('_csrf='))?.split('=')[1];



        const config = {

            url,

            method,

            data

        };



        // Set headers with CSRF token

        if (data instanceof FormData) {

            // For FormData, axios sets Content-Type automatically with boundary

            // But we need to explicitly set the CSRF header

            if (csrfToken) {

                config.headers = {

                    'x-csrf-token': csrfToken

                };

            }

        } else {

            // For JSON data, set Content-Type and CSRF token

            config.headers = {

                'Content-Type': 'application/json'

            };

            if (csrfToken) {

                config.headers['x-csrf-token'] = csrfToken;

            }

        }



        const response = await axios(config);



        return {

            success: true,

            status: response.status,

            data: response.data,

            error: false,

            message: response.data ?.message || 'Հաջողությամբ ստացվեց։'

        };

    } catch (error) {

        if (error.response) {

            return {

                success: false,

                status: error.response.status,

                data: null,

                error: true,

                message: error.response.data?.message || 'Սերվերից սխալ է ստացվել'

            };

        }



        return {

            success: false,

            status: null,

            data: null,

            error: true,

            message: error.message || 'Ցանցի կամ անհայտ սխալ'

        };

    }

}



function handlerNotify(message, type, iconColor = "#00ba00ff") {

    showNotification(message, type, 5000);

}



function setFormLoading(form, isLoading = true) {

    const btn = form.querySelector('button[type="submit"]');

    if (!btn) return;

    btn.disabled = isLoading;

}



document.addEventListener('DOMContentLoaded', function () {

    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))

    tooltipTriggerList.forEach(function (tooltipTriggerEl) {

        new bootstrap.Tooltip(tooltipTriggerEl)

    });

});



// setup Navigation Links

function setupNavLinks() {

    // This will find all navigation links

    const links = document.querySelectorAll('a[data-section]');

    links.forEach(link => {

        link.addEventListener('click', (e) => {

            e.preventDefault();

            const sectionId = link.getAttribute('data-section');

            if (window.location.pathname === '/' || window.location.pathname === '/') {

                const section = document.querySelector(`#${sectionId}`);

                if (section) section.scrollIntoView({

                    behavior: 'smooth'

                });

            } else {

                // Otherwise redirect to the home page with anchor

                window.location.href = `/${sectionId ? '#' + sectionId : ''}`;

            }

        });

    });

}



// Password show, hide

function exposePass() {

    var x = document.getElementById("xPassword");

    if (x.type === "password") {

        x.type = "text";

    } else {

        x.type = "password";

    }

}



function capLock(e) {

    kc = e.keyCode ? e.keyCode : e.which;

    sk = e.shiftKey ? e.shiftKey : ((kc == 16) ? true : false);

    if (((kc >= 65 && kc <= 90) && !sk) || ((kc >= 97 && kc <= 122) && sk))

        document.getElementById('capsOn').style.visibility = 'visible';

    else

        document.getElementById('capsOn').style.visibility = 'hidden';

}



function initPasswordToggle() {

    let passwordFields = document.querySelectorAll('.input_field');



    passwordFields.forEach(field => {

        let passwordInput = field.querySelector('input[type="password"]');



        if (passwordInput) {

            let button = document.createElement('button');

            button.type = "button";

            button.classList.add('password-show');

            button.innerHTML = '<i class="fa-solid fa-eye-slash"></i>';



            button.addEventListener('click', function () {

                if (passwordInput.type === "password") {

                    passwordInput.type = "text";

                    button.innerHTML = `<i class="fa-solid fa-eye"></i>`;

                } else {

                    passwordInput.type = "password";

                    button.innerHTML = `<i class="fa-solid fa-eye-slash"></i>`;

                }

            });

            field.appendChild(button);

        }

    });

}



function changeProfileImage() {

    const inputs = document.querySelectorAll('input[name="user_img"]');

    inputs.forEach(input => {

        input.addEventListener('change', async function(e) {

            const file = this.files && this.files[0];

            if (!file) return;



            const hasCropper = !!document.querySelector('[data-crop-wrapper]');

            const fromCrop = this.dataset.cropped === '1';

            if (hasCropper && !fromCrop) {

                return;

            }



            const preview = document.querySelector('.profile-img');

            const pSmImage = document.querySelector('.profime-sm-image');

            if (preview) preview.src = URL.createObjectURL(file);

            if (pSmImage) pSmImage.src = URL.createObjectURL(file);



            const formData = new FormData();

            formData.append('user_img', file);

            

            // Add CSRF token to FormData - read directly from meta tag or cookie

            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || 

                              document.cookie.split('; ').find(row => row.startsWith('_csrf='))?.split('=')[1];

            if (csrfToken) {

                formData.append('_csrf', csrfToken);

            }



            try {

                const response = await doAxios('/api/v1/user/updateme', 'patch', formData);

                if (response.status === 400) {

                    if (preview) preview.src = './client/images/no-image-profile.jpg';

                    if (pSmImage) pSmImage.src = './client/images/no-image-profile.jpg';

                }

                this.dataset.cropped = '';

            } catch (err) {

                // console.error('Upload failed:', err);

            }

        });

    });

}



function setupReviewForm() {

    const form = document.getElementById('reviewForm');

    if (!form) return;

    const btn = document.getElementById('reviewSubmitBtn');

    if (!btn) return;

    form.addEventListener('submit', (e) => e.preventDefault());

    btn.addEventListener('click', async () => {

        const fd = new FormData(form);

        if (form.dataset.hasReview === '1') {

            showNotification('Դուք արդեն մեկնաբանություն թողել եք', 'warning', 3000);

            return;

        }

        const rating = fd.get('rating');

        if (!rating) {

            showNotification('Ընտրեք գնահատականը (աստղերը)', 'warning', 3000);

            return;

        }

        const comment = String(fd.get('comment') || '').trim();

        if (!comment) {

            showNotification('Գրեք մեկնաբանության տեքստը', 'warning', 3000);

            const ta = form.querySelector('[name="comment"]');

            if (ta) ta.focus();

            return;

        }

        const proceed = await showModalConfirm({

            title: 'Հաստատում',

            message: 'Ձեր մեկնաբանությունը ենթակա չէ փոփոխման։ Շարունակե՞լ',

            confirmText: 'Այո, ուղարկել',

            cancelText: 'Չեղարկել'

        });

        if (!proceed) return;

        setFormLoading(form, true);

        try {

            const res = await doAxios('/api/v1/review', 'post', fd);

            if (res && res.success) {

                showNotification('Շնորհակալություն ձեր կարծիքի համար!', 'success', 3000);

                form.reset();

                form.dataset.hasReview = '1';

                setTimeout(() => window.location.reload(), 500);

            } else {

                showNotification(res?.message || 'Սխալ փորձի ժամանակ', 'error', 3000);

            }

        } catch (err) {

            showNotification('Չհաջողվեց ուղարկել', 'error', 3000);

        } finally {

            setFormLoading(form, false);

        }

    });

}



const accordionCollapseElementList = document.querySelectorAll('#headingThree .collapse')

const accordionCollapseList = [...accordionCollapseElementList].map(accordionCollapseEl => new bootstrap.Collapse(accordionCollapseEl))



function setupAuthModals() {

    const loginModalEl = document.getElementById('signIn_signUp');

    const forgotLink = document.getElementById('forgotPasswordLink');



    if (!loginModalEl) return;



    if (forgotLink) {

        forgotLink.addEventListener('click', async (e) => {

            e.preventDefault();

            

            // Find email input in the login form

            const form = loginModalEl.querySelector('form');

            const emailInput = form ? form.querySelector('input[name="email"]') : null;

            

            if (!emailInput) {

                showNotification('Էլ․ փոստի դաշտը չի գտնվել', 'warning', 3000);

                return;

            }



            const email = emailInput.value.trim();



            // Simple email validation regex

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;



            if (!email) {

                showNotification('Խնդրում ենք լրացնել էլ․ փոստը մուտքի դաշտում', 'warning', 3000);

                emailInput.focus();

                return;

            }



            if (!emailRegex.test(email)) {

                showNotification('Խնդրում ենք մուտքագրել վավեր էլ․ փոստ', 'warning', 3000);

                emailInput.focus();

                return;

            }



            // Send request

            try {

                // Disable link temporarily

                forgotLink.style.pointerEvents = 'none';

                forgotLink.style.opacity = '0.5';



                const formData = new FormData();

                formData.append('email', email);



                const response = await doAxios('/api/v1/user/forgotPassword', 'POST', formData);

                

                if (response.success) {

                    showNotification(response.message || 'Հղումը ուղարկված է էլ․ փոստին', 'success', 4000);

                } else {

                    showNotification(response.message || 'Սխալ տեղի ունեցավ', 'error', 4000);

                }

            } catch (err) {

                console.error(err);

                showNotification('Ցանցի սխալ', 'error', 3000);

            } finally {

                forgotLink.style.pointerEvents = '';

                forgotLink.style.opacity = '';

            }

        });

    }

    

    // Ensure backdrop is removed when modal is closed

    loginModalEl.addEventListener('hidden.bs.modal', function () {

            // If no other modal is open, remove backdrop

            // We use a small timeout to allow the other modal to show up if we are switching

            setTimeout(() => {

                if (!document.querySelector('.modal.show')) {

                    const backdrops = document.querySelectorAll('.modal-backdrop');

                    backdrops.forEach(backdrop => backdrop.remove());

                    document.body.classList.remove('modal-open');

                    document.body.style.paddingRight = '';

                    document.body.style.overflow = '';

                }

            }, 100);

    });

}



setupAuthModals();

changeProfileImage();

setupReviewForm();

initPasswordToggle();

setupNavLinks();

 